<div class="px-6 py-5 bg-white shadow form-card-wrapper-component" [attr.id]="props.id || null">
  <h2 class="fw-light">{{ props.title }}</h2>
  <div class="" *ngIf="props.summary" [innerHTML]="props.summary"></div>
  <ng-container #fieldComponent></ng-container>
</div>